import { makeManifestLikeReducerActions } from '../common/actions';

const { r, a } = makeManifestLikeReducerActions('manifest');

export const reducer = r;
export const actions = a;
